import { node, string } from 'prop-types'
import { Children } from 'react'
import { kuiperClassNames } from '../utils'
import Footer from './Footer'
import Header from './Header'
import Sidebar from './Sidebar'

import './styles.scss'

export { Header, Footer, Sidebar }

const baseLayerComponents = [Header, Footer, Sidebar]

function filterByChildType(children, childType) {
  return Children.toArray(children).filter((child) => {
    if (Array.isArray(childType)) {
      // filter children that are not base components
      return childType.indexOf(child.type) === -1
    }

    return child.type === childType
  })
}

const Layer = ({ children, className }) => (
  <div className={kuiperClassNames('layer', className)}>
    {filterByChildType(children, Sidebar)}
    <div className={kuiperClassNames('layer-content')}>
      {filterByChildType(children, Header)}
      <div className={kuiperClassNames('display-content')}>
        {filterByChildType(children, baseLayerComponents)}
      </div>
    </div>
    {filterByChildType(children, Footer)}
  </div>
)

Layer.propTypes = {
  children: node,
  className: string,
}

export default Layer
